<template>
  <money-collector-commission-form
      :initCommission="initCommission"
      :successMsg="t('commissionCreated')"
      :submitAction="submit"
      enableClearForm
      clearFormOnSubmit
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import MoneyCollectorCommissionForm from '@/views/hr/money-collector-commissions/MoneyCollectorCommissionForm.vue'

import MoneyCollectorCommission from '@/models/hr/MoneyCollectorCommission'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'new-money-collector-commission',
  components: {
    MoneyCollectorCommissionForm
  },
  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          commissionCreated: 'Money Collector Commission was created successfully'
        },
        ar: {
          commissionCreated: 'تم إنشاء عمولة جابي الأموال بنجاح'
        }
      }
    })

    return { t }
  },
  data() {
    return {
      initCommission: new MoneyCollectorCommission()
    }
  },

  methods: {
    async submit(commission: MoneyCollectorCommission) {
      try {
        await this.$http.post(MoneyCollectorCommission.ENDPOINT, commission)
        await this.$router.push(this.$Route.HR_MONEY_COLLECTOR_COMMISSIONS)
      } catch (error) {
        return error
      }
    }
  }
})
</script>

<style></style>
